import { Dialog, IconButton } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import * as React from "react";
import "./ModalImage.scss";

// tslint:disable-next-line:no-empty-interface
interface IProps {
  img: string;
  open?: boolean;
  onClose(): void;
}

// tslint:disable-next-line:no-empty-interface
interface IState {}

const IMAGES_URL = process.env.IMAGES_URL;

export class ModalImage extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  public render() {
    const { img, onClose, open } = this.props;

    return (
      <Dialog open={!!open} onClose={onClose}>
        <div className="modal-image">
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
          {!!img && !!IMAGES_URL && <img src={`${IMAGES_URL}${img}`} />}
        </div>
      </Dialog>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/shared/layout/components/ModalImage/ModalImage.tsx